import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { SolicitudResultadoBusqueda } from 'src/app/models/solicitud/solicitudResultadoBusqueda';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import {
  EstadoSolicitud,
  ParametrosMaestro,
  Roles,
  eTypeResult,
} from 'src/app/models/common/enumModel';
import { FilterSolicitudModel } from 'src/app/models/solicitud/FilterSolicitudModel';
import { IFilterSolicitudModel } from 'src/app/models/interfaces/solicitud/IFilterSolicitudModel';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { merge, Observable, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { ISolicitudExtenderModel } from 'src/app/models/interfaces/solicitud/ISolicitudExtenderModel';
import { MatDialog } from '@angular/material/dialog';

import { SolicitudExtenderModel } from 'src/app/models/solicitud/SolicitudExtenderModel';
import { SolicitudAmpliarPersonalModel } from 'src/app/models/solicitud/SolicitudAmpliarPersonalModel';

import { StorageService } from 'src/app/services/storage/storage.service';
import { SolicitudExtenderComponent } from '../solicitud-extender/solicitud-extender.component';
import { SolicitudAmpliarPersonalComponent } from '../solicitud-ampliar-personal/solicitud-ampliar-personal.component';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { SedeService } from 'src/app/services/sede/sede.service';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import * as fileSaver from 'file-saver';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { SolicitudStandByModel } from 'src/app/models/solicitud/SolicitudStandByModel';
import { SolicitudPonerStandByDialogComponent } from '../stand-by/solicitud-poner-stand-by-dialog/solicitud-poner-stand-by-dialog.component';
import { SolicitudQuitarStandByDialogComponent } from '../stand-by/solicitud-quitar-stand-by-dialog/solicitud-quitar-stand-by-dialog.component';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';

@Component({
  selector: 'app-solicitudes-bandeja-admin',
  templateUrl: './solicitudes-bandeja-admin.component.html',
  styleUrls: ['./solicitudes-bandeja-admin.component.scss']
})
export class SolicitudesBandejaAdminComponent implements OnInit {
  displayedColumns: string[] = [
    'codigo',
    'compania',
    'sede',
    'contratista',
    'solicitante',
    'trabajo',
    'fecha',
    'fechaInicio',
    'fechaFin',
    'tipoCreacion',
    'estado',
    'acciones',
  ]; // 'contacto',
  listaSolicitudes: SolicitudResultadoBusqueda[] =
    new Array<SolicitudResultadoBusqueda>();

  listaEstadosSolicitudes: ParametroModel[] = new Array<ParametroModel>();
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();

  model: IFilterSolicitudModel;
  resultsLength = 0;
  currentPage = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  puedeAprobar: boolean = false;
  esSolicitante: boolean = false;

  @ViewChild('paginator') paginator!: MatPaginator;
  constructor(
    public dialog: MatDialog,
    private service: SolicitudService,
    private parametrosService: ParametroService,
    private storage: StorageService,
    private sedeService: SedeService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) {
    this.model = new FilterSolicitudModel();
    //No se asignan fechas para la bandeja
    //this.model.fechaInicio = this.addDays(new Date(), -14);
    //this.model.fechaFin = new Date();
    this.model.pageSize = 30;
    //this.model.estados = [EstadoSolicitud.REVISADO, EstadoSolicitud.FINALIZADO, EstadoSolicitud.AUTORIZACION_ACCESOS, EstadoSolicitud.PROGRAMACION_INDUCCION, EstadoSolicitud.RESULTADOS_INDUCCION];
    let usuario = this.storage.getCurrentUser();
    this.puedeAprobar = usuario.selectedRoles.find((p) => p === Roles.SUPERVISOR) ? true : false;
    this.esSolicitante = usuario.selectedRoles.find((p) => p === Roles.SOLICITANTE) ? true : false;
    this.listaCompanias = usuario.companias;
    this.model.idCompania = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {
    this.companiaChanged();
    this.parametrosService
      .getDetalles(ParametrosMaestro.EstadosSolicitudes)
      .subscribe((data: SearchResultModel<ParametroModel[]>) => {
        this.listaEstadosSolicitudes = data.items;
      });

    this.search();
  }

  companiaChanged() {

    this.listaSedes = [];
    this.model.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.model.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  getPaginatorData(event: any) {
    this.model.page = event.pageIndex + 1;
    this.model.pageSize = event.pageSize;
    this.service
      .getListPorAdministrador(this.model)
      .subscribe((data: SearchResultModel<SolicitudResultadoBusqueda[]>) => {
        this.listaSolicitudes = data.items;
        this.resultsLength = data.total;
      });
  }

  delete(item: SolicitudResultadoBusqueda) {
    this.confirmDialogService.open(`¿Está seguro de borrar todos los datos de la solicitud ${item.codigo}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.service.delete(item.idSolicitud).subscribe((result) => {
          if (result.type == eTypeResult.SUCCESS) {
            this.search();
            this.alertDialogService.open('La solicitud fue eliminada');
          }
          else {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  search() {
    this.model.page = 1;
    this.service
      .getListPorAdministrador(this.model)
      .subscribe((data: SearchResultModel<SolicitudResultadoBusqueda[]>) => {
        this.listaSolicitudes = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  addDays(currentDate: Date, days: number): Date {
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  openDialogExtenderFin(solicitud: SolicitudResultadoBusqueda): void {
    let extensionModel = new SolicitudExtenderModel();
    extensionModel.idSolicitud = solicitud.idSolicitud;
    extensionModel.fechaFinAnterior = solicitud.fechaFin;

    const dialogRef = this.dialog.open(SolicitudExtenderComponent, {
      width: '500px',
      data: extensionModel,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.search();
    });
  }

  export() {
    //this.paginator.pageIndex = 0;
    this.model.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.service.getListPorAdministradorToExport(this.model).subscribe(
      (data) => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);

        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `solicitudes-administrador-${Date.now()}.xlsx`);

        //  this.createImageFromBlob(data);
        //  this.isImageLoading = false;
      },
      (error) => {
        //  this.isImageLoading = false;
        //  console.log(error);
      }
    );
  }

  isOldDate(fechaElva: string): Boolean {
    let fecha = new Date(fechaElva);
    let current = new Date();
    current.setHours(0, 0, 0, 0)
    return fecha >= current;
  }

  openDialogPonerStandBy(solicitud: SolicitudResultadoBusqueda): void {
    let solicitudModel = new SolicitudStandByModel();
    solicitudModel.idSolicitud = solicitud.idSolicitud;

    const dialogRef = this.dialog.open(SolicitudPonerStandByDialogComponent, {
      width: '500px',
      data: solicitudModel
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.search();
    });
  }

  openDialogQuitarStandBy(solicitud: SolicitudResultadoBusqueda): void {
    let solicitudModel = new SolicitudStandByModel();
    solicitudModel.idSolicitud = solicitud.idSolicitud;

    const dialogRef = this.dialog.open(SolicitudQuitarStandByDialogComponent, {
      width: '500px',
      data: solicitudModel
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.search();
    });
  }
}
